import { Component } from "react";
import { fetchAuthSession } from "aws-amplify/auth";
import { get, post, del } from "aws-amplify/api";
import { CONST } from "../environments/environment";
import { showModal } from "./common/showModal";
import { Tooltip as ReactTooltip } from "react-tooltip";
import * as bootstrap from "bootstrap";

// Git Credentialを取得する件数
export const GIT_CREDENTIAL_MAX_ITEMS = 20;
// export const GIT_CREDENTIAL_MAX_ITEMS = 2

export default class GitCredentialSection extends Component {
  constructor(props) {
    super(props);
    this.state = {
      // アクセスキー一覧（配列にJSONが入って返ってくる）
      git_credential_list: [],
      git_credential_max_items: 3,
      // グループ内のユーザー数が取り切れなかった場合のページング処理用
      git_credential_marker: [null],
      // Trueなら残りがある。Falseなら全て取り切った
      git_credential_is_remained_flag: true,
      git_credential_page: 0,

      created_git_user_name: null,
      created_git_password: null,
      created_user_number: null,
      created_git_credential_id: null,

      // 削除するユーザー名の末尾
      delete_user_number: null,
      delete_git_credential_id: null,
      delete_git_user_name: null,

      // エラー発生時のメッセージと発生機能名を管理
      error_message: null,
      error_function: null,
    };
    this.addGitCredential = this.addGitCredential.bind(this);
    this.deleteGitCredential = this.deleteGitCredential.bind(this);
    this.showGitPassword = this.showGitPassword.bind(this);
    this.setModalMessage = this.setModalMessage.bind(this);
  }
  async componentDidMount() {
    await this.getGitCredentialListPaging(0);
  }

  // 更新するマーカーの位置を切り替える関数
  switchUpdateMarker(continue_flag, marker_list, new_marker, page) {
    if (continue_flag) {
      // ファイルを最後まで取得しきれていない→マーカーを追加する
      if (page >= marker_list.length - 1) {
        // ページ番号がマーカーリストの最後の要素番号であれば、追加する
        marker_list.push(new_marker);
      } else {
        // 現在表示しているページの次のマーカーを更新
        marker_list[page + 1] = new_marker;
      }
    }
    return marker_list;
  }

  // 【機能1】Git Credential Listをページングで取得する関数
  async getGitCredentialListPaging(page) {
    try {
      await this.props.startLoading();
      let session = await fetchAuthSession();
      let api_name = CONST.API_NAME;
      let path = CONST.API_PATH.BASTION.GIT;
      let my_init = {
        headers: {
          Authorization: session.tokens?.idToken?.toString(),
        },
        queryParams: {
          accessToken: session.tokens?.accessToken?.toString(),
          bastionName: this.props.bastionName,
          // marker: this.state.git_credential_marker[page],
          ...(page > 0 && { marker: this.state.git_credential_marker[page] }),
          maxItems: GIT_CREDENTIAL_MAX_ITEMS,
        },
      };
      let response = await get({
        apiName: api_name,
        path,
        options: my_init,
      }).response;
      response = await response.body.json();
      // console.log(response);
      if ("errorMessage" in response) {
        throw response;
      }
      // Git Credentialを作成日時でソートする
      let gitCredentialListSorted = this.sortObjectArrayDesc(
        response.gitCredentialList,
      );
      await this.setState({
        git_credential_list: gitCredentialListSorted,
        git_credential_is_remained_flag: response.isRemainedFlag,
      });
      await this.setState({
        git_credential_marker: this.switchUpdateMarker(
          this.state.git_credential_is_remained_flag,
          this.state.git_credential_marker,
          response.marker,
          page,
        ),
        // 成功した場合のみページをセットする
        git_credential_page: page,
      });
      // await this.props.setEbEnvDetail(response);
      // await console.log(this.props.ebInfomation.envDetail);
    } catch (error) {
      // エラーモーダルを表示する
      await this.setState({
        error_function: "Gitクレデンシャル一覧取得",
        error_message: "お手数ですが時間を置き、再度お試しください。",
      });
      const el = document.getElementById("generalFailure");
      const modal = bootstrap.Modal.getOrCreateInstance(el);
      modal.show();
    } finally {
      await this.props.finishLoading();
    }
  }
  // JSONの配列を、更新日時で降順に並び替える
  sortObjectArrayDesc(object_array) {
    object_array.sort(function (a, b) {
      if (a.createDate > b.createDate) {
        return -1;
      }
      if (a.createDate < b.createDate) {
        return 1;
      }
      return 0;
    });
    return object_array;
  }

  // 【機能2】Gitクレデンシャルを発行する関数
  async addGitCredential() {
    try {
      await this.props.startLoading();
      let session = await fetchAuthSession();
      let api_name = CONST.API_NAME;
      let path = CONST.API_PATH.BASTION.GIT;
      let my_init = {
        headers: {
          Authorization: session.tokens?.idToken?.toString(),
        },
        body: {
          accessToken: session.tokens?.accessToken?.toString(),
          bastionName: this.props.bastionName,
        },
      };
      let response = await post({
        apiName: api_name,
        path,
        options: my_init,
      }).response;
      response = await response.body.json();
      // console.log(response);
      if ("errorMessage" in response) {
        throw response;
      }
      await this.setState({
        created_git_credential_id: response.gitCredentialId,
        created_git_password: response.gitPassword,
        created_git_user_name: response.gitUserName,
        created_user_number: response.userNumber,
      });
      // 取得が完了したら表示を更新する。配列にPushも可能だが、ページング処理的に見た目がおかしくなる
      // シークレットアクセスキーを表示するためのモーダルを表示する（背景クリックでモーダルを消させない）
      const el = document.getElementById("addSuccess");
      const modal = bootstrap.Modal.getOrCreateInstance(el, {
        backdrop: "static",
        keyboard: false,
      });
      modal.show();
      await this.getGitCredentialListPaging(0);
    } catch (error) {
      // エラーモーダルを表示する
      await this.setState({
        error_function: "Gitクレデンシャル追加",
        error_message: "お手数ですが時間を置き、再度お試しください。",
      });
      const el = document.getElementById("generalFailure");
      const modal = bootstrap.Modal.getOrCreateInstance(el);
      modal.show();
    } finally {
      await this.props.finishLoading();
    }
  }

  // 【機能3】Gitクレデンシャルを削除する関数
  async deleteGitCredential() {
    try {
      await this.props.startLoading();
      let session = await fetchAuthSession();
      let api_name = CONST.API_NAME;
      let path = CONST.API_PATH.BASTION.GIT;
      let my_init = {
        headers: {
          Authorization: session.tokens?.idToken?.toString(),
        },
        body: {
          accessToken: session.tokens?.accessToken?.toString(),
          bastionName: this.props.bastionName,
          gitCredentialId: this.state.delete_git_credential_id,
          // Gitクレデンシャル連番　＝　ユーザー末尾の番号
          gitCredentialSequence: this.state.delete_user_number,
        },
      };
      let response = await del({
        apiName: api_name,
        path,
        options: my_init,
      }).response;
      response = await response.body.json();
      // console.log(response);
      if ("errorMessage" in response) {
        throw response;
      }
      // 取得が完了したら表示を更新する。配列にPushも可能だが、ページング処理的に見た目がおかしくなる
      const el = document.getElementById("deleteSuccess");
      const modal = bootstrap.Modal.getOrCreateInstance(el);
      modal.show();
      await this.getGitCredentialListPaging(0);
    } catch (error) {
      // エラーモーダルを表示する
      await this.setState({
        error_function: "Gitクレデンシャル削除",
        error_message: "お手数ですが時間を置き、再度お試しください。",
      });
      const el = document.getElementById("generalFailure");
      const modal = bootstrap.Modal.getOrCreateInstance(el);
      modal.show();
    } finally {
      await this.props.finishLoading();
    }
  }
  // 削除用モーダルを表示する
  async deleteCommit(userNumber, gitCredentialId, userName) {
    await this.setState({
      delete_user_number: userNumber,
      delete_git_credential_id: gitCredentialId,
      delete_git_user_name: userName,
    });
    const el = document.getElementById("deleteConfirm");
    const modal = bootstrap.Modal.getOrCreateInstance(el);
    modal.show();
  }

  // Gitクレデンシャルリストを表に展開する
  recordCreater(array) {
    let list = [];
    array.map((data, index) => {
      list.push(
        <tr key={index}>
          {/* <td> {data.userNumber} </td> */}
          <td> {data.gitCredentialId} </td>
          <td> {data.gitUserName} </td>
          <td> {data.gitCredentialStatus} </td>
          <td> {data.createDate.slice(0, -3)} </td>
          <td>
            <button
              className={`btn btn-danger btn-sm`}
              onClick={() =>
                this.deleteCommit(
                  data.userNumber,
                  data.gitCredentialId,
                  data.gitUserName,
                )
              }
              disabled={this.props.isRootLoading}
            >
              {/* 削除 */}
              <i className="fas fa-trash-alt" />
            </button>
          </td>
        </tr>,
      );
    });
    return list;
  }
  // Gitクレデンシャル発行成功時にGitパスワードを表示するモーダル用コンポーネント
  showGitPassword() {
    let component = null;
    // secret access keyが取得できている間だけ表示する
    if (this.state.created_git_password !== null) {
      component = (
        <div className="">
          {/* No
          <input
            type="text"
            readOnly={true}
            value={this.state.created_user_number}
            className="form-control"
          />
          <br /> */}
          ユーザー名
          <input
            type="text"
            readOnly={true}
            value={this.state.created_git_user_name}
            className="form-control"
          />
          <br />
          パスワード
          <input
            type="text"
            readOnly={true}
            value={this.state.created_git_password}
            className="form-control"
          />
          <br />
          <br />
          <strong className="text-danger">
            ※パスワードは今この画面でのみ確認が可能です。再表示することはできませんので、ご注意ください。
          </strong>
        </div>
      );
    }
    return component;
  }
  // 削除成功時のモーダル表示用コンポーネント
  showDeleteSuccess(message) {
    let component = (
      <div>
        {message}
        <br />
        <br />
        <div className="row">
          <div className="col-sm-3">GitクレデンシャルID</div>
          <div className="col-sm-1">：</div>
          <div className="col-sm-8">{this.state.delete_git_credential_id}</div>
        </div>
        <div className="row">
          <div className="col-sm-3">ユーザー名</div>
          <div className="col-sm-1">：</div>
          <div className="col-sm-8">{this.state.delete_git_user_name}</div>
        </div>
        {/* No　　　　　　：　{this.state.delete_user_number}
        <br /> */}
      </div>
    );
    return component;
  }
  // エラーモーダル用
  emptyReturn() {
    return null;
  }
  // エラーモーダルにメッセージを表示する
  setModalMessage() {
    let message = "エラーが発生しました。";
    if (this.state.error_function !== null) {
      message = [
        `${this.state.error_function}に失敗しました。`,
        <br key={1} />,
        `${this.state.error_message}`,
      ];
    }
    return message;
  }

  render() {
    return (
      <div className="section d-flex justify-content-center">
        <div className="card custom-card-height general-card">
          <div className="card-header h5">
            <div className="float-left mt-2">
              <i className="fas fa-key mr-2" />
              Gitクレデンシャル
            </div>
            {/* 更新ボタン */}
            <button
              className={`btn btn-light float-right`}
              onClick={() => this.getGitCredentialListPaging(0)}
              data-tooltip-content="Gitクレデンシャルの一覧が更新されます。"
              data-tooltip-id="refreshAccessKeyToolTip"
              // ReactTooltipを仕込んだボタンを無効化すると、ツールチップが消えなくなる
              // disabled={this.props.isRootLoading}
            >
              <i className="fas fa-sync-alt" />
              <ReactTooltip
                id="refreshAccessKeyToolTip"
                effect="solid"
                place="top"
              />
            </button>
            {/* 戻るボタン */}
            <button
              type="button"
              className="btn btn-light float-right"
              onClick={() => this.props.showClientEnvList()}
              data-tooltip-content="開発環境の一覧画面に戻ります。"
              data-tooltip-id="backAccessKeyToolTip"
              // disabled={this.props.isRootLoading}
            >
              <i className="fas fa-reply mr-2" />
              開発環境一覧に戻る
              <ReactTooltip
                id="backAccessKeyToolTip"
                effect="solid"
                place="left"
              />
            </button>
          </div>
          <div className="card-body custom-scroll small">
            <span className="h5">
              <i className="fas fa-window-restore mr-2" />
              開発環境名: {this.props.bastionName}
              {/* Gitクレデンシャル発行ボタン */}
              <button
                className="btn btn-primary ml-5"
                onClick={() => {
                  const el = document.getElementById("addConfirm");
                  const modal = bootstrap.Modal.getOrCreateInstance(el);
                  modal.show();
                }}
                disabled={this.props.isRootLoading}
              >
                <i className="fas fa-plus-circle mr-2" />
                Gitクレデンシャルを追加
              </button>
            </span>
            <div className="mt-4 mb-4">
              <div className="input-group">
                <div className="input-group-prepend">
                  <span className="input-group-text bg-light" id="clone-url">
                    {/* <i className="fas fa-angle-double-right mr-2" /> */}
                    Gitクローン用HTTPS URL
                  </span>
                </div>
                <input
                  type="text"
                  readOnly={true}
                  value={`https://git-codecommit.ap-northeast-1.amazonaws.com/v1/repos/${this.props.bastionName}-codecommit`}
                  className="form-control"
                  aria-describedby="clone-url"
                />
              </div>
            </div>

            <table className="table table-bordered custom-table-width mt-2">
              <thead>
                <tr>
                  {/* <th scope="col" className="custom-td-width-number">
                    No
                  </th> */}
                  <th scope="col" className="custom-td-width-eb-env-name-long">
                    GitクレデンシャルID
                  </th>
                  <th scope="col" className="custom-td-width-eb-env-name-long">
                    ユーザー名
                  </th>
                  <th scope="col" className="custom-td-width-alpha7">
                    ステータス
                  </th>
                  <th scope="col" className="custom-td-width-eb-day-long">
                    作成日時
                  </th>
                  <th scope="col" className="custom-td-width-number">
                    削除
                  </th>
                </tr>
              </thead>
              <tbody>
                {this.recordCreater(this.state.git_credential_list)}
              </tbody>
            </table>
          </div>
          {/* ページ用セクション */}
          <div className="text-center">
            <button
              className="btn"
              onClick={() =>
                this.getGitCredentialListPaging(
                  this.state.git_credential_page - 1,
                )
              }
              disabled={
                this.state.git_credential_page <= 0 || this.props.isRootLoading
              }
            >
              前
            </button>
            <button className="btn" disabled={true}>
              {this.state.git_credential_page + 1}
            </button>
            <button
              className="btn"
              onClick={() =>
                this.getGitCredentialListPaging(
                  this.state.git_credential_page + 1,
                )
              }
              disabled={
                !this.state.git_credential_is_remained_flag ||
                this.props.isRootLoading
              }
            >
              次
            </button>
          </div>
        </div>

        {/* モーダル：アクセスキー追加確認 */}
        {/* 追加確認 */}
        {showModal({
          modalId: "addConfirm",
          modalTitle: (
            <span>
              <i className="fas fa-info-circle text-primary mr-2" />
              確認
            </span>
          ),
          modalBody: (
            <div>
              Gitクレデンシャルを追加してもよろしいですか？
              <br />
              <br />
              <strong className="text-danger">
                ※パスワードは発行時に1度のみ表示され、再表示することはできませんので、ご注意ください。
              </strong>
            </div>
          ),
          executeFunctionObject: this.addGitCredential,
        })}
        {/* 追加成功 */}
        {showModal({
          modalId: "addSuccess",
          modalTitle: (
            <span className="text-success">
              <i className="fas fa-check-circle mr-2" />
              成功
            </span>
          ),
          modalBody: this.showGitPassword(),
          executeButtonLabel: "OK",
          showCancelButtonFlag: false,
          executeFunctionObject: this.emptyReturn,
        })}

        {/* 追加失敗 */}
        {showModal({
          modalId: "addFailure",
          modalTitle: (
            <span className="text-danger">
              <i className="fas fa-exclamation-circle mr-2" />
              エラー
            </span>
          ),
          modalBody: "エラーが発生しました。",
          executeButtonLabel: "OK",
          showCancelButtonFlag: false,
          executeFunctionObject: this.emptyReturn,
        })}
        {/* モーダル */}

        {/* モーダル：アクセスキー削除確認・成功・失敗 */}
        {/* 削除確認 */}
        {showModal({
          modalId: "deleteConfirm",
          modalTitle: (
            <span>
              <i className="fas fa-info-circle text-primary mr-2" />
              確認
            </span>
          ),
          modalBody: this.showDeleteSuccess(
            "以下のGitクレデンシャルを削除してもよろしいですか？",
          ),
          executeFunctionObject: this.deleteGitCredential,
          executeButtonColor: "danger",
        })}
        {/* 削除成功 */}
        {showModal({
          modalId: "deleteSuccess",
          modalTitle: (
            <span className="text-success">
              <i className="fas fa-check-circle mr-2" />
              成功
            </span>
          ),
          modalBody: this.showDeleteSuccess(
            "以下のGitクレデンシャルを削除しました。",
          ),
          executeButtonLabel: "OK",
          showCancelButtonFlag: false,
          executeFunctionObject: this.emptyReturn,
        })}
        {/* 削除失敗 */}
        {showModal({
          modalId: "deleteFailure",
          modalTitle: (
            <span className="text-danger">
              <i className="fas fa-exclamation-circle mr-2" />
              エラー
            </span>
          ),
          modalBody: "エラーが発生しました。",
          executeButtonLabel: "OK",
          showCancelButtonFlag: false,
          executeFunctionObject: this.emptyReturn,
        })}
        {/* エラー */}
        {showModal({
          modalId: "generalFailure",
          modalTitle: (
            <span className="text-danger">
              <i className="fas fa-exclamation-circle mr-2" />
              エラー
            </span>
          ),
          modalBody: this.setModalMessage(),
          executeButtonLabel: "OK",
          showCancelButtonFlag: false,
          executeFunctionObject: this.emptyReturn,
        })}
      </div>
    );
  }
}
